import { configureStore } from "@reduxjs/toolkit";

import CityReducer from "../features/AdminPanel/CityList/CityListSlice";
import JobSkillsReducer from "../features/AdminPanel/JobPostingSlice/JobSkillsList/JobSkillsSlice";
import JobEducationReducer from "../features/AdminPanel/JobPostingSlice/JobEducation/JobEducationSlice";
import JobDepartmentReducer from "../features/AdminPanel/JobPostingSlice/JobDepartment/JobDepartmentSlice";
import JobCompanyReducer from "../features/AdminPanel/JobCompanyList/JobCompanyListSlice";
import JobEducationCourseReducer from "../features/AdminPanel/JobPostingSlice/JobEducationCourse/JobEducationCourceSlice";
import JobReducer from "../features/employers/Employers Slice/employerJobs/employerJobSlice";
import JobListReducer from "../features/employers/Employers Slice/employerJobList/employerJobListSlice";

import CompanyReviewsReducer from "../features/employerDashboard/employerDashboardSlice/employerCompanyReviews/CompanyReviewsSlice";
import JobTitlesReducer from "../features/AdminPanel/JobPostingSlice/JobTitles/JobTitlesSlice";
import CompanyListReducer from "../features/Company/CompanySlice/CompanyListSlice";
import jobsByCompanyReducer from "../features//Company/JobsByCompanySlice/JobsByCompanySlice";
import CandidateListReducer from "../features/employerDashboard/components/Candidate/CandidateSlice/Basic/CandidateSlice";
import InterviewReducer from "../features/employerDashboard/components/Candidate/CandidateSlice/Interview/InterviewSlice";
import authTokenSlice from "../features/common/FetchTokenSlice";
import createJobReducer from "../features/employers/Employers Slice/employersJobCreateSlice/createJobSlice";
import companyProfileSlice from "../features/employerDashboard/employerDashAPIs/companyProfile/CompanyProfileSlice";
import auth from "../features/auth/authSlices";
import SearchedCandidatesReducer from "../features/employerDashboard/components/Candidate/CandidateSlice/CandidateSearch/CandidateSearchSlice";
import addEmployerReducer from "../features/employerDashboard/employerDashboardSlice/employerProfileCreation/EmployerBasicsSlice";
import publicJobListReducer from "../features/jobList/publicJobListSlice/publicJobListSlice";
import publicJobDetailReducer from "../features/jobList/publicJobDescription/publicJobDescriptionSlice";
import jobCategoryListReducer from "../features/jobCategories/JobCategorySlice/JobCategorySlice";
import latestJobListReducer from "../features/jobList/LatestJobList/LatestJobListSlice";
import jobRolesReducer from "../features/JobRoles/JobRolesSlice";
import topCompaniesReducer from "../features/TopCompanies/TopCompaniesSlice";
import popularJobRolesListReducer from "../features/jobList/PopularJobRolesList/PopularJobRolesListSlice";
import popularJobCategoriesListReducer from "../features/jobList/PopularJobCategoriesList/PopularJobCategoriesListSlice";

import publicCoreLocationsReducer from "../features/jobSearch/FetchLocationSlice/FetchLocationSlice";
import companyDetailsReducer from "../features/Company/CompanySingleSlice/CompanySingleSlice";
import testimonialsReducer from "../features/AdminPanel/Testimonials/TestimonialsSlice";
import employerLogoReducer from "../features/employerDashboard/employerDashboardSlice/EmployerLogo/EmployerLogoSlice";
import publicCompanyReviewsReducer from "../features/Public/PublicCompanyReviews/PublicCompanyReviewsSlice";
import jobEducationCourseSpecialtyReducer from "../features/AdminPanel/JobPostingSlice/JobEducationCourseSpecialty/JobEducationCourseSpecialtySlice";
import errorMiddleware from "../features/common/errorMiddleware";
import errorReducer from "../features/common/errorSlice";

import JobPublishOrUnpublishReducer from "../features/employerDashboard/employerDashboardSlice/JobPublish/JobPublishSlice"
import ApplicantListByJobReducer from "../features/employerDashboard/employerDashboardSlice/applicantListByJob/applicantListByJobSlice"

import coreIndustryReducer from "../features/AdminPanel/CoreIndustry/CoreIndustrySlice";
import SubscriptionSlice from "../features/AdminPanel/Subscriptions/SubscriptionDetails/SubscriptionSlice";
import subscriptionCustomReducer from "../features/AdminPanel/Subscriptions/SubscriptionCustom/SubscriptionCustomSlice"
import CandidateDataSlice from "../features/AdminPanel/CandidateData/CandidateDataSlice";
import EmployerDataSlice from "../features/AdminPanel/EmployerData/EmployerDataSlice";
import employerSubscriptionsReducer from "../features/employerDashboard/employerDashboardSlice/EmployerSubscriptions/EmployerSubscriptionsSlice"
import employerSubscriptionsTopUpReducer from "../features/employerDashboard/employerDashboardSlice/EmployerSubscriptionTopUp/EmployerSubscriptionTopUpSlice"
import employerActiveSubscriptionReducer from "../features/employerDashboard/employerDashboardSlice/EmployerActiveSubscriptions/EmployerActiveSubscriptionSlice"
import subscriptionTopUpReducer from "../features/AdminPanel/Subscriptions/SubscriptionTopUp/SubscriptionTopUpSlice"
import adminReviewsReducer from "../features/AdminPanel/AdminReviews/AdminReviewsSlice"
import companyMediaReducer from "../features/employerDashboard/employerMedia/EmployerMediaSlice"
import companyInterviewReducer from "../features/employerDashboard/employerInterviewProcess/EmployerInterviewSlice"
import adminJobListReducer from "../features/AdminPanel/JobList/AdminJobListSlice"
import AboutYouReducer from "../features/employerDashboard/AboutYou/AboutSlice"

import emailReducer from "../features/auth/Slice/PasswordResetRequest/PasswordResetRequestSlice"
import passwordReducer from "../features/auth/Slice/PasswordReset/PasswordResetSlice"
import changePasswordReducer from "../features/auth/Slice/PasswordChange/PasswordChangeSlice"
import emailVerificationReducer from "../features/auth/Slice/EmailVerification/EmailVerificationSlice"
import UrgentHiringTagReducer from "../features/employerDashboard/employerDashboardSlice/UrgentHiringTag/UrgentHiringTagSlice"
import UnlockCandidateReducer from "../features/employerDashboard/employerDashboardSlice/UnlockCandidate/UnlockCandidateSlice"
import UnlockedCandidateListReducer from "../features/employerDashboard/employerDashboardSlice/UnlockedCandidateList/UnlockedCandidateListSlice"
import UnlockCandidateFromJobApplyReducer from "../features/employerDashboard/employerDashboardSlice/UnlockCandidateFromJobApply/UnlockCandidateFromJobApplySlice"
import ShowCandidateReducer from "../features/employerDashboard/employerDashboardSlice/ShowCandidateDetails/ShowCandidateDetailsSlice"
import employerpublicsubscriptionReducer from "../pages/EmployerPublicSubscription/EmployerPublicSubscriptionSlice"
import contactUsPublicReducer from "../features/ContactUsHome/ContactUsHomeSlice"
import employerSavedCandidateReducer from "../features/employerDashboard/components/Candidate/CandidateSlice/EmployerSaveCandidate/EmployerSaveCandidateSlice"
import employerCandidateJobApplyExportbyStatusReducer from "../features/employerDashboard/employerDataExports/employerCandidateJobApplyListByStatusExport/employerCandidateJobApplyListByStatusExportSlice"
import employerCandidateUnlockListExportReducer from "../features/employerDashboard/employerDataExports/employerCandidateUnlockListExport/employerCandidateUnlockListExportSlice"
import employerCandidateJobApplyExportByJobUuidReducer from "../features/employerDashboard/employerDataExports/employerCandidateJobApplyListByJobUuidExport/employerCandidateJobApplyListByJobUuidExportSlice"
import checkEmailVerificationReducer from "../features/auth/Slice/EmailVerificationSignup/EmailVerificationSignupSlice"
import checkPhoneVerificationReducer from "../features/auth/Slice/PhoneVerificationSignup/PhoneVerificationSignupSlice"

export const store = configureStore({
  reducer: {
    auth: auth,
    authTokenReducer: authTokenSlice,
    eDashCmpyProfile: companyProfileSlice,
    jobTitles: JobTitlesReducer,
    jobSkills: JobSkillsReducer,
    jobEducation: JobEducationReducer,
    jobDepartments: JobDepartmentReducer,
    jobCompanyList: JobCompanyReducer,
    jobEducationCourse: JobEducationCourseReducer,
    city: CityReducer,
    adminJobList: adminJobListReducer,

    ShowCandidate: ShowCandidateReducer,
    UnlockCandidate: UnlockCandidateReducer,
    UnlockedCandidateList: UnlockedCandidateListReducer,
    UnlockCandidateFromJobApply: UnlockCandidateFromJobApplyReducer,

    UrgentHiringTag: UrgentHiringTagReducer,
    coreIndustry: coreIndustryReducer,
    subscription: SubscriptionSlice,
    candidateData: CandidateDataSlice,
    employerData: EmployerDataSlice,
    subscriptionCustom: subscriptionCustomReducer,
    subscriptionTopUp: subscriptionTopUpReducer,

    testimonials: testimonialsReducer,
    adminReviews: adminReviewsReducer,
    jobEducationCourseSpecialty: jobEducationCourseSpecialtyReducer,

    global: errorReducer,
    email: emailReducer,
    password: passwordReducer,
    changePassword: changePasswordReducer,
    emailVerification: emailVerificationReducer,

    aboutYou: AboutYouReducer,


    employerBasics: addEmployerReducer,
    companyMedia: companyMediaReducer,
    companyInterview: companyInterviewReducer,

    employerLogo: employerLogoReducer,
    companyReviews: CompanyReviewsReducer,
    companies: CompanyListReducer,
    jobsByCompany: jobsByCompanyReducer,
    candidateList: CandidateListReducer,
    interview: InterviewReducer,
    searchedCandidates: SearchedCandidatesReducer,
    jobPublishOrUnpublish: JobPublishOrUnpublishReducer,
    applicantListByJob: ApplicantListByJobReducer,
    employerSubscriptions: employerSubscriptionsReducer,
    employerSubscriptionsTopUp: employerSubscriptionsTopUpReducer,
    employerActiveSubscription: employerActiveSubscriptionReducer,
    employerSavedCandidate: employerSavedCandidateReducer,
    employerCandidateJobApplyExportbyStatus: employerCandidateJobApplyExportbyStatusReducer,
    employerCandidateUnlockListExport: employerCandidateUnlockListExportReducer,
    employerCandidateJobApplyExportByJobUuid: employerCandidateJobApplyExportByJobUuidReducer,
    job: JobReducer,
    jobList: JobListReducer,

    // job details
    createJobReducers: createJobReducer,

    // public APIs
    publicJobList: publicJobListReducer,
    contactUsPublic: contactUsPublicReducer,
    publicJobDetail: publicJobDetailReducer,
    latestJobList: latestJobListReducer,
    popularJobRolesList: popularJobRolesListReducer,
    popularJobCategoriesList: popularJobCategoriesListReducer,
    jobCategoryList: jobCategoryListReducer,
    employerpublicsubscription: employerpublicsubscriptionReducer,
    jobRoles: jobRolesReducer,
    topCompanies: topCompaniesReducer,
    publicCoreLocations: publicCoreLocationsReducer,
    companyDetails: companyDetailsReducer,
    publicCompanyReviews: publicCompanyReviewsReducer,
    emailVerificationPublic: checkEmailVerificationReducer,
    phoneVerificationPublic: checkPhoneVerificationReducer,

  },

  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(errorMiddleware),
});
